import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { FC } from "react";
import { IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction } from "../../../../generated";
import { FormatDate} from "../../../../constants";

export interface TransactionsPDFProps {
  data: TransactionPdfData;
  amountLabel?: string;

}

export interface TransactionPdfData {
  amountLabel: string;
  tableData: IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction;
}

const styles = StyleSheet.create({
  body: {
    padding: 15,
    margin: 2,
    fontSize: 14,
    height: "90%",
  },
  title: {
    fontFamily: "Helvetica-Bold",
    fontSize: 20,
    marginBottom: 10,
  },
  horizontalLine: {
    borderTop: 2,
    borderColor: "black",
    height: 2,
    marginBottom: 5,
    marginTop: 2,
  },
  table: {
    display: "flex",
    width: "100%",
    marginBottom: 5,
    paddingRight: 20,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
    marginBottom: 15,
  },
  tableCell: {
    fontSize: 10,
  },
  label: {
    fontFamily: "Times-Roman",
    fontSize: 9,
    marginBottom: 5,
  },
  content: {
    fontSize: 11,
  },
});

interface InfoGroupProps {
  label: string;
  content: string;
}

const InfoGroup: FC<InfoGroupProps> = (props) => {
  return (
    <>
      <Text style={styles.label}>{props.label}</Text>
      <Text style={styles.content}>{props.content}</Text>
    </>
  );
};

export const TransactionsGeneratePdf: FC<TransactionsPDFProps> = (props) => {
  const tranData = props.data.tableData;
  const refId = tranData?.transactionReference?.referenceId ?? "";

  return (
    <Document title={`Staff - ${refId}`}>
      <Page orientation="landscape" size="A4" style={styles.body}>
        <View style={styles.horizontalLine}></View>
        <View style={styles.title}>
          <Text>Transactions Summary</Text>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={{ width: "50%" }}>
              <View style={styles.tableCell}>
                <InfoGroup label={"Transaction ID:"} content={refId} />
              </View>
            </View>
            <View style={{ width: "50%" }}>
              <View style={styles.tableCell}>
                <InfoGroup label={"Transaction Date:"} content={tranData?.createdAt ? FormatDate(tranData.createdAt) : "N/A"} />
              </View>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={{ width: "50%" }}>
              <View style={styles.tableCell}>
                <InfoGroup label={"Description:"} content={tranData?.reason ?? "N/A"} />
              </View>
            </View>
            <View style={{ width: "50%" }}>
              <View style={styles.tableCell}>
                <InfoGroup label={props?.data?.amountLabel} content={tranData?.amount !== undefined ? `US$${Math.abs(tranData?.amount || 0)}` : "N/A"} />
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};